import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';

import { BarChart, Bar, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line, ResponsiveContainer } from 'recharts';
import Measure from 'react-measure';

import { prepareRequest } from "src/services/reports.service";
import { Dropdown } from 'react-bootstrap';

import styles from './styles.module.scss';

import _ from 'lodash';
import isEqual from "is-equal";
import { localizedStrings } from 'src/localization/index';
import CustomTooltip from "src/components/tooltip"

class Timeseries extends React.Component {
  constructor(props) {
    super(props);

    this.localizedCommonLoading = localizedStrings.commons.loading;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedFilters = this.localizedReport.tabs.engagement.cards.filters;

    this.state = {
      request: null,
      xdataKey: "",
      lineDatakey: "",
      userType: { name: this.localizedFilters.all_viewers, value: "all" },
      showInfoTooltip: false
    }

    this.handleOptionSelection = this.handleOptionSelection.bind(this);
  }

  componentDidMount() {
    this.loadReport(this.props.request);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.request, nextProps.request)) {
      this.loadReport(nextProps.request);
    }
  }

  loadReport(request) {
    if (!request) {
      return;
    }

    const processedRequest = prepareRequest(request, this.props.supportedEntities);
    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState({
        request: processedRequest
      }, () => {
        this.props.fetchData(processedRequest);
      })
    }
  }

  handleOptionSelection(field) {
    document.body.click(); //Close popover

    var newRequest = {
      ...this.state.request,
      userType: field.value
    };

    this.setState({
      userType: field,
      request: newRequest
    },
      () => {
        this.props.fetchData(newRequest);
      }
    );
  }

  handleMouseEnter = () => {
    this.setState({
      showInfoTooltip: true
    })
  }

  handleMouseLeave = () => {
    this.setState({
      showInfoTooltip: false
    })
  }

  render() {
    return (
      <div className={cx(styles.timeseries, this.props.className)}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={styles.content}>
          <h5 className={styles.title}>{this.props.title}
            {this.state.showInfoTooltip && _.size(this.props.tooltipText) > 0 &&
              <span className={cx(styles.infoTooltipContainer)}>
                <CustomTooltip content={this.props.tooltipText} placement="top">
                  <i className="paperflite-info"></i>
                </CustomTooltip>
              </span>
            }
          </h5>
          {this.props.canFilterByUserType &&
            this.renderUserTypeFilter()
          }
        </div>

        {this.props.loading &&
          <div className={styles.loading}>{this.localizedCommonLoading.loading}...</div>
        }

        {!this.props.loading &&
          this.renderChart()
        }

      </div>
    );
  }

  renderChart() {
    return (
      <ResponsiveContainer>
        <BarChart
          data={this.props.data}
          margin={{ top: 40, right: -20, bottom: 0, left: 0 }}
        >
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <XAxis dataKey="key" axisLine={false} tickFormatter={this.formatXAxis} />
          <YAxis
            dataKey="value"
            axisLine={false}
            orientation='right'
            tickLine={false}
            padding={{ left: 10 }}
            type="number"
            interval={'preserveStartEnd'}
            domain={[0, 'dataMax']}
            tickFormatter={this.formatYAxis.bind(this)}
          />
          <Tooltip content={this.formatToolTip.bind(this)} cursor={false} />
          {/* <Bar dataKey="value" fill="$primary-color" maxBarSize={10} /> */}
          <Bar dataKey="value" fill="$primary-color" maxBarSize={10} />
        </BarChart>
      </ResponsiveContainer>
    );
  }

  renderUserTypeFilter() {
    var fields = [
      {
        name: this.localizedFilters.all_viewers,
        value: "all",
      },
      {
        name: this.localizedFilters.known_viewers,
        value: "known",
      },
      {
        name: this.localizedFilters.anonymous_viewers,
        value: "anonymous",
      }
    ];

    return <Dropdown>
      <Dropdown.Toggle className={styles.dropdownButton} as={'button'}>
        <img className={styles.filterList} />
        <span className={styles.type}>{this.state.userType.name}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenuContainer} popperConfig={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 6],
            },
          },
        ],
      }}>
        {fields.map((item, index) => {
          var active = isEqual(this.state.userType.value, item.value);
          return <Dropdown.Item key={index}
            className={cx(styles.dropdownItem, { [styles.active]: active })}
            onClick={() => this.handleOptionSelection(item)}>
            {item.name}
          </Dropdown.Item>
        })}
      </Dropdown.Menu>
    </Dropdown>

  }

  formatXAxis(tickItem) {
    return dateformat(tickItem, 'dd-mmm')
  }

  formatYAxis(tickItem) {
    if (this.props.tickFormater) {
      return this.props.tickFormater(tickItem);
    }

    return tickItem;
  }

  formatToolTip(prop) {
    const { active } = prop;
    if (active) {
      const { payload } = prop
      const payloadObj = _.get(payload, '[0].payload', null);

      var value = _.get(payloadObj, 'value', "");
      if (this.props.valueFormater) {
        value = this.props.valueFormater(value);
      }

      return (
        <div className={styles.tooltip}>
          <p className="key">{`${this.props.legend.key} : ${dateformat(_.get(payloadObj, "key", ""), 'dd-mmm-yyyy')}`}</p>
          <p className="value">{`${this.props.legend.value} : ${value}`}</p>
        </div>
      );
    }

    return null;
  }
}

Timeseries.defaultProps = {
  title: ''
};

export default Timeseries;